import { Component, OnInit, inject, signal } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService }            from '../services/auth.service';
import { BiometricAuthService }   from '../services/biometric-auth.service';
import { BrandMarkComponent }     from '../../shared/brand-mark.component';

@Component({
  selector: 'app-biometric-lock',
  standalone: true,
  imports: [BrandMarkComponent],
  templateUrl: './biometric-lock.component.html'
})
export class BiometricLockComponent implements OnInit {
  private readonly biometric = inject(BiometricAuthService);
  private readonly auth      = inject(AuthService);
  private readonly router    = inject(Router);

  protected readonly authenticating = signal(false);
  protected readonly errorMessage   = signal<string | null>(null);
  protected readonly biometryLabel  = signal<string>('Face ID / fingerprint');

  async ngOnInit(): Promise<void> {
    const a = await this.biometric.checkAvailability();
    if (a.label) { this.biometryLabel.set(a.label); }
    void this.tryUnlock();
  }

  protected async tryUnlock(): Promise<void> {
    if (this.authenticating()) { return; }
    this.authenticating.set(true);
    this.errorMessage.set(null);
    const ok = await this.biometric.unlock();
    this.authenticating.set(false);
    if (ok) {
      this.biometric.clearLock();
    } else {
      this.errorMessage.set(`Unable to unlock with ${this.biometryLabel()}. Try again or use your password.`);
    }
  }

  /** Bypass biometric — sign out and force a fresh password login. */
  protected usePassword(): void {
    this.auth.clearTokens();
    this.biometric.clearLock();
    this.router.navigateByUrl('/auth/login');
  }
}
